import { useTranslation } from 'react-i18next';

import { useNotification } from 'providers/NotificationProvider';

export const useChangePasswordAlerts = () => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  const passwordChanged = () => {
    showNotification({
      title: t('notifications:success-action'),
      type: 'success',
    });
  };

  const invalidRequest = () => {
    showNotification({
      title: t('notifications:invalid-action'),
      type: 'error',
    });
  };

  const invalidOldPassword = () => {
    showNotification({
      title: t('myProfile:password.invalid-password'),
      type: 'error',
    });
  };

  return { passwordChanged, invalidRequest, invalidOldPassword };
};
